import { useStore } from 'vuex';
import { computed } from 'vue';
import { SET_MODAL_OVERLAY_VISIBILITY } from '@atomic-ui/modalOverlay';
// import { lockScroll } from '../utils/scroll';

const SET_MODAL_OVERLAY_VISIBILITY_MUTATION = `modalOverlayStore/${SET_MODAL_OVERLAY_VISIBILITY}`;

/**
 * Composable function to open and close modal windows
 *
 * @returns {{
 *  open: (name: string) => void,
 *  activeModal: import('vue').ComputedRef<string>
 * }}
 */
export default function useModal() {
  const store = useStore();

  /**
   * Opens named modal window
   * @param {string} name - name of modal window to open
   */
  const open = (name) => {
    store.commit(SET_MODAL_OVERLAY_VISIBILITY_MUTATION, name);
    // lockScroll(true);
  };

  /**
   * Returns name of active modal window
   * @returns {import('vue').ComputedRef<strin>}
   */
  const activeModal = computed(() => {
    /** @type {Record<string, any>} */
    const showModalObj = store.state.modalOverlayStore.showModal;
    return Object.keys(showModalObj)[0];
  });

  return { open, activeModal };
}
